/* eslint-disable */
/* ⚠️ DO NOT EDIT ⚠️ */
/* This file is automatically generated, run 'pnpm codegen' to update */
import * as Types from '../../../__generated__/schema.types';

import { CmTeasableCommon_CmArticleImpl_Fragment, CmTeasableCommon_CmAudioImpl_Fragment, CmTeasableCommon_CmChannelImpl_Fragment, CmTeasableCommon_CmCollectionImpl_Fragment, CmTeasableCommon_CmDownloadImpl_Fragment, CmTeasableCommon_CmDynamicListImpl_Fragment, CmTeasableCommon_CmExternalLinkImpl_Fragment, CmTeasableCommon_CmGalleryImpl_Fragment, CmTeasableCommon_CmhtmlImpl_Fragment, CmTeasableCommon_CmImageMapImpl_Fragment, CmTeasableCommon_CmInteractiveImpl_Fragment, CmTeasableCommon_CmLocTaxonomyImpl_Fragment, CmTeasableCommon_CmMediaImpl_Fragment, CmTeasableCommon_CmNavigationImpl_Fragment, CmTeasableCommon_CmPersonImpl_Fragment, CmTeasableCommon_CmPictureImpl_Fragment, CmTeasableCommon_CmPlaceholderImpl_Fragment, CmTeasableCommon_CmProductImpl_Fragment, CmTeasableCommon_CmQueryListImpl_Fragment, CmTeasableCommon_CmSelectionRulesImpl_Fragment, CmTeasableCommon_CmSpinnerImpl_Fragment, CmTeasableCommon_CmTaxonomyImpl_Fragment, CmTeasableCommon_CmTeasableImpl_Fragment, CmTeasableCommon_CmTeaserImpl_Fragment, CmTeasableCommon_CmVideoImpl_Fragment, CmTeasableCommon_CmVisualImpl_Fragment, CmTeasableCommon_FormEditorImpl_Fragment, CmTeasableCommon_SosAmountIncreaseFormImpl_Fragment, CmTeasableCommon_SosAuthorImpl_Fragment, CmTeasableCommon_SosChartImpl_Fragment, CmTeasableCommon_SosContactImpl_Fragment, CmTeasableCommon_SosDonationCardImpl_Fragment, CmTeasableCommon_SosDonationCertificateImpl_Fragment, CmTeasableCommon_SosDonationFormImpl_Fragment, CmTeasableCommon_SosDonationProductImpl_Fragment, CmTeasableCommon_SosDonationProgressImpl_Fragment, CmTeasableCommon_SosDonationToolImpl_Fragment, CmTeasableCommon_SosEventImpl_Fragment, CmTeasableCommon_SosFilterTeaserImpl_Fragment, CmTeasableCommon_SosInternalLinkImpl_Fragment, CmTeasableCommon_SosJobTeaserImpl_Fragment, CmTeasableCommon_SosLocationImpl_Fragment, CmTeasableCommon_SosNewsImpl_Fragment, CmTeasableCommon_SosNotificationImpl_Fragment, CmTeasableCommon_SosOfferImpl_Fragment, CmTeasableCommon_SosOrderFormImpl_Fragment, CmTeasableCommon_SosOrganisationImpl_Fragment, CmTeasableCommon_SosOverlayImpl_Fragment, CmTeasableCommon_SosPressreleaseImpl_Fragment, CmTeasableCommon_SosPublicationImpl_Fragment, CmTeasableCommon_SosRedirectPageImpl_Fragment, CmTeasableCommon_SosSpecialTopicCategoryImpl_Fragment, CmTeasableCommon_SosSpecialTopicImpl_Fragment, CmTeasableCommon_SosTeaserImpl_Fragment, CmTeasableCommon_SosTextfragmentImpl_Fragment, CmTeasableCommon_SosTooltipImpl_Fragment, CmTeasableCommon_SosWimmelbildImpl_Fragment, CmTeasableCommon_ViewTypeHeroCollection_Fragment } from './CMTeasableCommon.fragment';
import { CmTeasableLayout_CmArticleImpl_Fragment, CmTeasableLayout_CmAudioImpl_Fragment, CmTeasableLayout_CmChannelImpl_Fragment, CmTeasableLayout_CmCollectionImpl_Fragment, CmTeasableLayout_CmDownloadImpl_Fragment, CmTeasableLayout_CmDynamicListImpl_Fragment, CmTeasableLayout_CmExternalLinkImpl_Fragment, CmTeasableLayout_CmGalleryImpl_Fragment, CmTeasableLayout_CmhtmlImpl_Fragment, CmTeasableLayout_CmImageMapImpl_Fragment, CmTeasableLayout_CmInteractiveImpl_Fragment, CmTeasableLayout_CmLocTaxonomyImpl_Fragment, CmTeasableLayout_CmMediaImpl_Fragment, CmTeasableLayout_CmNavigationImpl_Fragment, CmTeasableLayout_CmPersonImpl_Fragment, CmTeasableLayout_CmPictureImpl_Fragment, CmTeasableLayout_CmPlaceholderImpl_Fragment, CmTeasableLayout_CmProductImpl_Fragment, CmTeasableLayout_CmQueryListImpl_Fragment, CmTeasableLayout_CmSelectionRulesImpl_Fragment, CmTeasableLayout_CmSpinnerImpl_Fragment, CmTeasableLayout_CmTaxonomyImpl_Fragment, CmTeasableLayout_CmTeasableImpl_Fragment, CmTeasableLayout_CmTeaserImpl_Fragment, CmTeasableLayout_CmVideoImpl_Fragment, CmTeasableLayout_CmVisualImpl_Fragment, CmTeasableLayout_FormEditorImpl_Fragment, CmTeasableLayout_SosAmountIncreaseFormImpl_Fragment, CmTeasableLayout_SosAuthorImpl_Fragment, CmTeasableLayout_SosChartImpl_Fragment, CmTeasableLayout_SosContactImpl_Fragment, CmTeasableLayout_SosDonationCardImpl_Fragment, CmTeasableLayout_SosDonationCertificateImpl_Fragment, CmTeasableLayout_SosDonationFormImpl_Fragment, CmTeasableLayout_SosDonationProductImpl_Fragment, CmTeasableLayout_SosDonationProgressImpl_Fragment, CmTeasableLayout_SosDonationToolImpl_Fragment, CmTeasableLayout_SosEventImpl_Fragment, CmTeasableLayout_SosFilterTeaserImpl_Fragment, CmTeasableLayout_SosInternalLinkImpl_Fragment, CmTeasableLayout_SosJobTeaserImpl_Fragment, CmTeasableLayout_SosLocationImpl_Fragment, CmTeasableLayout_SosNewsImpl_Fragment, CmTeasableLayout_SosNotificationImpl_Fragment, CmTeasableLayout_SosOfferImpl_Fragment, CmTeasableLayout_SosOrderFormImpl_Fragment, CmTeasableLayout_SosOrganisationImpl_Fragment, CmTeasableLayout_SosOverlayImpl_Fragment, CmTeasableLayout_SosPressreleaseImpl_Fragment, CmTeasableLayout_SosPublicationImpl_Fragment, CmTeasableLayout_SosRedirectPageImpl_Fragment, CmTeasableLayout_SosSpecialTopicCategoryImpl_Fragment, CmTeasableLayout_SosSpecialTopicImpl_Fragment, CmTeasableLayout_SosTeaserImpl_Fragment, CmTeasableLayout_SosTextfragmentImpl_Fragment, CmTeasableLayout_SosTooltipImpl_Fragment, CmTeasableLayout_SosWimmelbildImpl_Fragment, CmTeasableLayout_ViewTypeHeroCollection_Fragment } from './CMTeasableLayout.fragment';
import { CmTeasableTeaserTarget_CmArticleImpl_Fragment, CmTeasableTeaserTarget_CmAudioImpl_Fragment, CmTeasableTeaserTarget_CmChannelImpl_Fragment, CmTeasableTeaserTarget_CmCollectionImpl_Fragment, CmTeasableTeaserTarget_CmDownloadImpl_Fragment, CmTeasableTeaserTarget_CmDynamicListImpl_Fragment, CmTeasableTeaserTarget_CmExternalLinkImpl_Fragment, CmTeasableTeaserTarget_CmGalleryImpl_Fragment, CmTeasableTeaserTarget_CmhtmlImpl_Fragment, CmTeasableTeaserTarget_CmImageMapImpl_Fragment, CmTeasableTeaserTarget_CmInteractiveImpl_Fragment, CmTeasableTeaserTarget_CmLocTaxonomyImpl_Fragment, CmTeasableTeaserTarget_CmMediaImpl_Fragment, CmTeasableTeaserTarget_CmNavigationImpl_Fragment, CmTeasableTeaserTarget_CmPersonImpl_Fragment, CmTeasableTeaserTarget_CmPictureImpl_Fragment, CmTeasableTeaserTarget_CmPlaceholderImpl_Fragment, CmTeasableTeaserTarget_CmProductImpl_Fragment, CmTeasableTeaserTarget_CmQueryListImpl_Fragment, CmTeasableTeaserTarget_CmSelectionRulesImpl_Fragment, CmTeasableTeaserTarget_CmSpinnerImpl_Fragment, CmTeasableTeaserTarget_CmTaxonomyImpl_Fragment, CmTeasableTeaserTarget_CmTeasableImpl_Fragment, CmTeasableTeaserTarget_CmTeaserImpl_Fragment, CmTeasableTeaserTarget_CmVideoImpl_Fragment, CmTeasableTeaserTarget_CmVisualImpl_Fragment, CmTeasableTeaserTarget_FormEditorImpl_Fragment, CmTeasableTeaserTarget_SosAmountIncreaseFormImpl_Fragment, CmTeasableTeaserTarget_SosAuthorImpl_Fragment, CmTeasableTeaserTarget_SosChartImpl_Fragment, CmTeasableTeaserTarget_SosContactImpl_Fragment, CmTeasableTeaserTarget_SosDonationCardImpl_Fragment, CmTeasableTeaserTarget_SosDonationCertificateImpl_Fragment, CmTeasableTeaserTarget_SosDonationFormImpl_Fragment, CmTeasableTeaserTarget_SosDonationProductImpl_Fragment, CmTeasableTeaserTarget_SosDonationProgressImpl_Fragment, CmTeasableTeaserTarget_SosDonationToolImpl_Fragment, CmTeasableTeaserTarget_SosEventImpl_Fragment, CmTeasableTeaserTarget_SosFilterTeaserImpl_Fragment, CmTeasableTeaserTarget_SosInternalLinkImpl_Fragment, CmTeasableTeaserTarget_SosJobTeaserImpl_Fragment, CmTeasableTeaserTarget_SosLocationImpl_Fragment, CmTeasableTeaserTarget_SosNewsImpl_Fragment, CmTeasableTeaserTarget_SosNotificationImpl_Fragment, CmTeasableTeaserTarget_SosOfferImpl_Fragment, CmTeasableTeaserTarget_SosOrderFormImpl_Fragment, CmTeasableTeaserTarget_SosOrganisationImpl_Fragment, CmTeasableTeaserTarget_SosOverlayImpl_Fragment, CmTeasableTeaserTarget_SosPressreleaseImpl_Fragment, CmTeasableTeaserTarget_SosPublicationImpl_Fragment, CmTeasableTeaserTarget_SosRedirectPageImpl_Fragment, CmTeasableTeaserTarget_SosSpecialTopicCategoryImpl_Fragment, CmTeasableTeaserTarget_SosSpecialTopicImpl_Fragment, CmTeasableTeaserTarget_SosTeaserImpl_Fragment, CmTeasableTeaserTarget_SosTextfragmentImpl_Fragment, CmTeasableTeaserTarget_SosTooltipImpl_Fragment, CmTeasableTeaserTarget_SosWimmelbildImpl_Fragment, CmTeasableTeaserTarget_ViewTypeHeroCollection_Fragment } from './CMTeasebleTeaserTarget.fragment';
import { CmDownloadFragment } from './CMDownload.fragment';
import { CmExternalLinkFragment } from './CMExternalLink.fragment';
import { CmPictureForCollectionFragment } from './CMPictureForCollection.fragment';
import { CmCollection2_CmCollectionImpl_Fragment, CmCollection2_CmDynamicListImpl_Fragment, CmCollection2_CmGalleryImpl_Fragment, CmCollection2_CmQueryListImpl_Fragment, CmCollection2_CmSelectionRulesImpl_Fragment, CmCollection2_ViewTypeHeroCollection_Fragment } from './CMCollection2.fragment';
import { CmhtmlFragment } from './CMHtml.fragment';
import { SosTextfragmentFragment } from './SOSTextfragment.fragment';
import { SosTeaserFragment } from './SOSTeaser.fragment';
import { SosDonationCardFragment } from './SOSDonationCard.fragment';
import { SosFilterTeaserFragment } from './SOSFilterTeaser.fragment';
import { SosDonationProductFragment } from './SOSDonationProduct.fragment';
import { gql } from '@apollo/client';
import { CmTeasableCommonFragmentDoc } from './CMTeasableCommon.fragment';
import { CmTeasableLayoutFragmentDoc } from './CMTeasableLayout.fragment';
import { CmTeasableTeaserTargetFragmentDoc } from './CMTeasebleTeaserTarget.fragment';
import { CmDownloadFragmentDoc } from './CMDownload.fragment';
import { CmExternalLinkFragmentDoc } from './CMExternalLink.fragment';
import { CmPictureForCollectionFragmentDoc } from './CMPictureForCollection.fragment';
import { CmCollection2FragmentDoc } from './CMCollection2.fragment';
import { CmhtmlFragmentDoc } from './CMHtml.fragment';
import { SosTextfragmentFragmentDoc } from './SOSTextfragment.fragment';
import { SosTeaserFragmentDoc } from './SOSTeaser.fragment';
import { SosDonationCardFragmentDoc } from './SOSDonationCard.fragment';
import { SosFilterTeaserFragmentDoc } from './SOSFilterTeaser.fragment';
import { SosDonationProductFragmentDoc } from './SOSDonationProduct.fragment';
export type CmCollection_CmCollectionImpl_Fragment = (
  { __typename?: 'CMCollectionImpl', viewtype?: string | null, callToActionSettings?: any | null, downloadSettings?: any | null, teaserCarouselSettings?: any | null, queryListSettings?: any | null, donationProductPriceSettings?: any | null, subjectTeaserSettings?: any | null, accordionSettings?: any | null, c016GlobalFilterSettings?: any | null, items?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmTeasableCommon_CmArticleImpl_Fragment
    & CmTeasableTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmTeasableCommon_CmAudioImpl_Fragment
    & CmTeasableTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmTeasableCommon_CmChannelImpl_Fragment
    & CmTeasableTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmTeasableCommon_CmCollectionImpl_Fragment
    & CmTeasableTeaserTarget_CmCollectionImpl_Fragment
    & CmCollection2_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmTeasableCommon_CmDownloadImpl_Fragment
    & CmTeasableTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmTeasableCommon_CmDynamicListImpl_Fragment
    & CmTeasableTeaserTarget_CmDynamicListImpl_Fragment
    & CmCollection2_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmTeasableCommon_CmExternalLinkImpl_Fragment
    & CmTeasableTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmTeasableCommon_CmGalleryImpl_Fragment
    & CmTeasableTeaserTarget_CmGalleryImpl_Fragment
    & CmCollection2_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmTeasableCommon_CmhtmlImpl_Fragment
    & CmTeasableTeaserTarget_CmhtmlImpl_Fragment
    & CmhtmlFragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmTeasableCommon_CmImageMapImpl_Fragment
    & CmTeasableTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmTeasableCommon_CmInteractiveImpl_Fragment
    & CmTeasableTeaserTarget_CmInteractiveImpl_Fragment
  ) | { __typename?: 'CMLinkableImpl' } | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTeasableCommon_CmLocTaxonomyImpl_Fragment
    & CmTeasableTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmTeasableCommon_CmMediaImpl_Fragment
    & CmTeasableTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmTeasableCommon_CmNavigationImpl_Fragment
    & CmTeasableTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmTeasableCommon_CmPersonImpl_Fragment
    & CmTeasableTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmTeasableCommon_CmPictureImpl_Fragment
    & CmTeasableTeaserTarget_CmPictureImpl_Fragment
    & CmPictureForCollectionFragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmTeasableCommon_CmPlaceholderImpl_Fragment
    & CmTeasableTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmTeasableCommon_CmProductImpl_Fragment
    & CmTeasableTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmTeasableCommon_CmQueryListImpl_Fragment
    & CmTeasableTeaserTarget_CmQueryListImpl_Fragment
    & CmCollection2_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmTeasableCommon_CmSelectionRulesImpl_Fragment
    & CmTeasableTeaserTarget_CmSelectionRulesImpl_Fragment
    & CmCollection2_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmTeasableCommon_CmSpinnerImpl_Fragment
    & CmTeasableTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTeasableCommon_CmTaxonomyImpl_Fragment
    & CmTeasableTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmTeasableCommon_CmTeasableImpl_Fragment
    & CmTeasableTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmTeasableCommon_CmTeaserImpl_Fragment
    & CmTeasableTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmTeasableCommon_CmVideoImpl_Fragment
    & CmTeasableTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmTeasableCommon_CmVisualImpl_Fragment
    & CmTeasableTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmTeasableCommon_FormEditorImpl_Fragment
    & CmTeasableTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmTeasableCommon_SosAmountIncreaseFormImpl_Fragment
    & CmTeasableTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmTeasableCommon_SosAuthorImpl_Fragment
    & CmTeasableTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmTeasableCommon_SosChartImpl_Fragment
    & CmTeasableTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmTeasableCommon_SosContactImpl_Fragment
    & CmTeasableTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmTeasableCommon_SosDonationCardImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationCardImpl_Fragment
    & SosDonationCardFragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmTeasableCommon_SosDonationCertificateImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmTeasableCommon_SosDonationFormImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmTeasableCommon_SosDonationProductImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationProductImpl_Fragment
    & SosDonationProductFragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmTeasableCommon_SosDonationProgressImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmTeasableCommon_SosDonationToolImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmTeasableCommon_SosEventImpl_Fragment
    & CmTeasableTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmTeasableCommon_SosFilterTeaserImpl_Fragment
    & CmTeasableTeaserTarget_SosFilterTeaserImpl_Fragment
    & SosFilterTeaserFragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmTeasableCommon_SosInternalLinkImpl_Fragment
    & CmTeasableTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmTeasableCommon_SosJobTeaserImpl_Fragment
    & CmTeasableTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTeasableCommon_SosLocationImpl_Fragment
    & CmTeasableTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmTeasableCommon_SosNewsImpl_Fragment
    & CmTeasableTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmTeasableCommon_SosNotificationImpl_Fragment
    & CmTeasableTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmTeasableCommon_SosOfferImpl_Fragment
    & CmTeasableTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmTeasableCommon_SosOrderFormImpl_Fragment
    & CmTeasableTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmTeasableCommon_SosOrganisationImpl_Fragment
    & CmTeasableTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmTeasableCommon_SosOverlayImpl_Fragment
    & CmTeasableTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmTeasableCommon_SosPressreleaseImpl_Fragment
    & CmTeasableTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmTeasableCommon_SosPublicationImpl_Fragment
    & CmTeasableTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmTeasableCommon_SosRedirectPageImpl_Fragment
    & CmTeasableTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmTeasableCommon_SosSpecialTopicCategoryImpl_Fragment
    & CmTeasableTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmTeasableCommon_SosSpecialTopicImpl_Fragment
    & CmTeasableTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmTeasableCommon_SosTeaserImpl_Fragment
    & CmTeasableTeaserTarget_SosTeaserImpl_Fragment
    & SosTeaserFragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmTeasableCommon_SosTextfragmentImpl_Fragment
    & CmTeasableTeaserTarget_SosTextfragmentImpl_Fragment
    & SosTextfragmentFragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmTeasableCommon_SosTooltipImpl_Fragment
    & CmTeasableTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmTeasableCommon_SosWimmelbildImpl_Fragment
    & CmTeasableTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmTeasableCommon_ViewTypeHeroCollection_Fragment
    & CmTeasableTeaserTarget_ViewTypeHeroCollection_Fragment
    & CmCollection2_ViewTypeHeroCollection_Fragment
  ) | null> | null, teasableItems?: Array<{ __typename?: 'CMArticleImpl' } | { __typename?: 'CMAudioImpl' } | { __typename?: 'CMChannelImpl' } | (
    { __typename?: 'CMCollectionImpl' }
    & CmCollection2_CmCollectionImpl_Fragment
  ) | { __typename?: 'CMDownloadImpl' } | (
    { __typename?: 'CMDynamicListImpl' }
    & CmCollection2_CmDynamicListImpl_Fragment
  ) | { __typename?: 'CMExternalLinkImpl' } | (
    { __typename?: 'CMGalleryImpl' }
    & CmCollection2_CmGalleryImpl_Fragment
  ) | { __typename?: 'CMHTMLImpl' } | { __typename?: 'CMImageMapImpl' } | { __typename?: 'CMInteractiveImpl' } | { __typename?: 'CMLocTaxonomyImpl' } | { __typename?: 'CMMediaImpl' } | { __typename?: 'CMNavigationImpl' } | { __typename?: 'CMPersonImpl' } | { __typename?: 'CMPictureImpl' } | { __typename?: 'CMPlaceholderImpl' } | { __typename?: 'CMProductImpl' } | (
    { __typename?: 'CMQueryListImpl' }
    & CmCollection2_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmCollection2_CmSelectionRulesImpl_Fragment
  ) | { __typename?: 'CMSpinnerImpl' } | { __typename?: 'CMTaxonomyImpl' } | { __typename?: 'CMTeasableImpl' } | { __typename?: 'CMTeaserImpl' } | { __typename?: 'CMVideoImpl' } | { __typename?: 'CMVisualImpl' } | { __typename?: 'FormEditorImpl' } | { __typename?: 'SOSAmountIncreaseFormImpl' } | { __typename?: 'SOSAuthorImpl' } | { __typename?: 'SOSChartImpl' } | { __typename?: 'SOSContactImpl' } | { __typename?: 'SOSDonationCardImpl' } | { __typename?: 'SOSDonationCertificateImpl' } | { __typename?: 'SOSDonationFormImpl' } | { __typename?: 'SOSDonationProductImpl' } | { __typename?: 'SOSDonationProgressImpl' } | { __typename?: 'SOSDonationToolImpl' } | { __typename?: 'SOSEventImpl' } | { __typename?: 'SOSFilterTeaserImpl' } | { __typename?: 'SOSInternalLinkImpl' } | { __typename?: 'SOSJobTeaserImpl' } | { __typename?: 'SOSLocationImpl' } | { __typename?: 'SOSNewsImpl' } | { __typename?: 'SOSNotificationImpl' } | { __typename?: 'SOSOfferImpl' } | { __typename?: 'SOSOrderFormImpl' } | { __typename?: 'SOSOrganisationImpl' } | { __typename?: 'SOSOverlayImpl' } | { __typename?: 'SOSPressreleaseImpl' } | { __typename?: 'SOSPublicationImpl' } | { __typename?: 'SOSRedirectPageImpl' } | { __typename?: 'SOSSpecialTopicCategoryImpl' } | { __typename?: 'SOSSpecialTopicImpl' } | { __typename?: 'SOSTeaserImpl' } | { __typename?: 'SOSTextfragmentImpl' } | { __typename?: 'SOSTooltipImpl' } | { __typename?: 'SOSWimmelbildImpl' } | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmCollection2_ViewTypeHeroCollection_Fragment
  ) | null> | null }
  & CmTeasableCommon_CmCollectionImpl_Fragment
  & CmTeasableLayout_CmCollectionImpl_Fragment
);

export type CmCollection_CmDynamicListImpl_Fragment = (
  { __typename?: 'CMDynamicListImpl', viewtype?: string | null, callToActionSettings?: any | null, downloadSettings?: any | null, teaserCarouselSettings?: any | null, queryListSettings?: any | null, donationProductPriceSettings?: any | null, subjectTeaserSettings?: any | null, accordionSettings?: any | null, c016GlobalFilterSettings?: any | null, items?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmTeasableCommon_CmArticleImpl_Fragment
    & CmTeasableTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmTeasableCommon_CmAudioImpl_Fragment
    & CmTeasableTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmTeasableCommon_CmChannelImpl_Fragment
    & CmTeasableTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmTeasableCommon_CmCollectionImpl_Fragment
    & CmTeasableTeaserTarget_CmCollectionImpl_Fragment
    & CmCollection2_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmTeasableCommon_CmDownloadImpl_Fragment
    & CmTeasableTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmTeasableCommon_CmDynamicListImpl_Fragment
    & CmTeasableTeaserTarget_CmDynamicListImpl_Fragment
    & CmCollection2_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmTeasableCommon_CmExternalLinkImpl_Fragment
    & CmTeasableTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmTeasableCommon_CmGalleryImpl_Fragment
    & CmTeasableTeaserTarget_CmGalleryImpl_Fragment
    & CmCollection2_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmTeasableCommon_CmhtmlImpl_Fragment
    & CmTeasableTeaserTarget_CmhtmlImpl_Fragment
    & CmhtmlFragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmTeasableCommon_CmImageMapImpl_Fragment
    & CmTeasableTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmTeasableCommon_CmInteractiveImpl_Fragment
    & CmTeasableTeaserTarget_CmInteractiveImpl_Fragment
  ) | { __typename?: 'CMLinkableImpl' } | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTeasableCommon_CmLocTaxonomyImpl_Fragment
    & CmTeasableTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmTeasableCommon_CmMediaImpl_Fragment
    & CmTeasableTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmTeasableCommon_CmNavigationImpl_Fragment
    & CmTeasableTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmTeasableCommon_CmPersonImpl_Fragment
    & CmTeasableTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmTeasableCommon_CmPictureImpl_Fragment
    & CmTeasableTeaserTarget_CmPictureImpl_Fragment
    & CmPictureForCollectionFragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmTeasableCommon_CmPlaceholderImpl_Fragment
    & CmTeasableTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmTeasableCommon_CmProductImpl_Fragment
    & CmTeasableTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmTeasableCommon_CmQueryListImpl_Fragment
    & CmTeasableTeaserTarget_CmQueryListImpl_Fragment
    & CmCollection2_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmTeasableCommon_CmSelectionRulesImpl_Fragment
    & CmTeasableTeaserTarget_CmSelectionRulesImpl_Fragment
    & CmCollection2_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmTeasableCommon_CmSpinnerImpl_Fragment
    & CmTeasableTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTeasableCommon_CmTaxonomyImpl_Fragment
    & CmTeasableTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmTeasableCommon_CmTeasableImpl_Fragment
    & CmTeasableTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmTeasableCommon_CmTeaserImpl_Fragment
    & CmTeasableTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmTeasableCommon_CmVideoImpl_Fragment
    & CmTeasableTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmTeasableCommon_CmVisualImpl_Fragment
    & CmTeasableTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmTeasableCommon_FormEditorImpl_Fragment
    & CmTeasableTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmTeasableCommon_SosAmountIncreaseFormImpl_Fragment
    & CmTeasableTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmTeasableCommon_SosAuthorImpl_Fragment
    & CmTeasableTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmTeasableCommon_SosChartImpl_Fragment
    & CmTeasableTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmTeasableCommon_SosContactImpl_Fragment
    & CmTeasableTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmTeasableCommon_SosDonationCardImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationCardImpl_Fragment
    & SosDonationCardFragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmTeasableCommon_SosDonationCertificateImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmTeasableCommon_SosDonationFormImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmTeasableCommon_SosDonationProductImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationProductImpl_Fragment
    & SosDonationProductFragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmTeasableCommon_SosDonationProgressImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmTeasableCommon_SosDonationToolImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmTeasableCommon_SosEventImpl_Fragment
    & CmTeasableTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmTeasableCommon_SosFilterTeaserImpl_Fragment
    & CmTeasableTeaserTarget_SosFilterTeaserImpl_Fragment
    & SosFilterTeaserFragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmTeasableCommon_SosInternalLinkImpl_Fragment
    & CmTeasableTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmTeasableCommon_SosJobTeaserImpl_Fragment
    & CmTeasableTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTeasableCommon_SosLocationImpl_Fragment
    & CmTeasableTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmTeasableCommon_SosNewsImpl_Fragment
    & CmTeasableTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmTeasableCommon_SosNotificationImpl_Fragment
    & CmTeasableTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmTeasableCommon_SosOfferImpl_Fragment
    & CmTeasableTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmTeasableCommon_SosOrderFormImpl_Fragment
    & CmTeasableTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmTeasableCommon_SosOrganisationImpl_Fragment
    & CmTeasableTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmTeasableCommon_SosOverlayImpl_Fragment
    & CmTeasableTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmTeasableCommon_SosPressreleaseImpl_Fragment
    & CmTeasableTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmTeasableCommon_SosPublicationImpl_Fragment
    & CmTeasableTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmTeasableCommon_SosRedirectPageImpl_Fragment
    & CmTeasableTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmTeasableCommon_SosSpecialTopicCategoryImpl_Fragment
    & CmTeasableTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmTeasableCommon_SosSpecialTopicImpl_Fragment
    & CmTeasableTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmTeasableCommon_SosTeaserImpl_Fragment
    & CmTeasableTeaserTarget_SosTeaserImpl_Fragment
    & SosTeaserFragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmTeasableCommon_SosTextfragmentImpl_Fragment
    & CmTeasableTeaserTarget_SosTextfragmentImpl_Fragment
    & SosTextfragmentFragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmTeasableCommon_SosTooltipImpl_Fragment
    & CmTeasableTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmTeasableCommon_SosWimmelbildImpl_Fragment
    & CmTeasableTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmTeasableCommon_ViewTypeHeroCollection_Fragment
    & CmTeasableTeaserTarget_ViewTypeHeroCollection_Fragment
    & CmCollection2_ViewTypeHeroCollection_Fragment
  ) | null> | null, teasableItems?: Array<{ __typename?: 'CMArticleImpl' } | { __typename?: 'CMAudioImpl' } | { __typename?: 'CMChannelImpl' } | (
    { __typename?: 'CMCollectionImpl' }
    & CmCollection2_CmCollectionImpl_Fragment
  ) | { __typename?: 'CMDownloadImpl' } | (
    { __typename?: 'CMDynamicListImpl' }
    & CmCollection2_CmDynamicListImpl_Fragment
  ) | { __typename?: 'CMExternalLinkImpl' } | (
    { __typename?: 'CMGalleryImpl' }
    & CmCollection2_CmGalleryImpl_Fragment
  ) | { __typename?: 'CMHTMLImpl' } | { __typename?: 'CMImageMapImpl' } | { __typename?: 'CMInteractiveImpl' } | { __typename?: 'CMLocTaxonomyImpl' } | { __typename?: 'CMMediaImpl' } | { __typename?: 'CMNavigationImpl' } | { __typename?: 'CMPersonImpl' } | { __typename?: 'CMPictureImpl' } | { __typename?: 'CMPlaceholderImpl' } | { __typename?: 'CMProductImpl' } | (
    { __typename?: 'CMQueryListImpl' }
    & CmCollection2_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmCollection2_CmSelectionRulesImpl_Fragment
  ) | { __typename?: 'CMSpinnerImpl' } | { __typename?: 'CMTaxonomyImpl' } | { __typename?: 'CMTeasableImpl' } | { __typename?: 'CMTeaserImpl' } | { __typename?: 'CMVideoImpl' } | { __typename?: 'CMVisualImpl' } | { __typename?: 'FormEditorImpl' } | { __typename?: 'SOSAmountIncreaseFormImpl' } | { __typename?: 'SOSAuthorImpl' } | { __typename?: 'SOSChartImpl' } | { __typename?: 'SOSContactImpl' } | { __typename?: 'SOSDonationCardImpl' } | { __typename?: 'SOSDonationCertificateImpl' } | { __typename?: 'SOSDonationFormImpl' } | { __typename?: 'SOSDonationProductImpl' } | { __typename?: 'SOSDonationProgressImpl' } | { __typename?: 'SOSDonationToolImpl' } | { __typename?: 'SOSEventImpl' } | { __typename?: 'SOSFilterTeaserImpl' } | { __typename?: 'SOSInternalLinkImpl' } | { __typename?: 'SOSJobTeaserImpl' } | { __typename?: 'SOSLocationImpl' } | { __typename?: 'SOSNewsImpl' } | { __typename?: 'SOSNotificationImpl' } | { __typename?: 'SOSOfferImpl' } | { __typename?: 'SOSOrderFormImpl' } | { __typename?: 'SOSOrganisationImpl' } | { __typename?: 'SOSOverlayImpl' } | { __typename?: 'SOSPressreleaseImpl' } | { __typename?: 'SOSPublicationImpl' } | { __typename?: 'SOSRedirectPageImpl' } | { __typename?: 'SOSSpecialTopicCategoryImpl' } | { __typename?: 'SOSSpecialTopicImpl' } | { __typename?: 'SOSTeaserImpl' } | { __typename?: 'SOSTextfragmentImpl' } | { __typename?: 'SOSTooltipImpl' } | { __typename?: 'SOSWimmelbildImpl' } | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmCollection2_ViewTypeHeroCollection_Fragment
  ) | null> | null }
  & CmTeasableCommon_CmDynamicListImpl_Fragment
  & CmTeasableLayout_CmDynamicListImpl_Fragment
);

export type CmCollection_CmGalleryImpl_Fragment = (
  { __typename?: 'CMGalleryImpl', viewtype?: string | null, callToActionSettings?: any | null, downloadSettings?: any | null, teaserCarouselSettings?: any | null, queryListSettings?: any | null, donationProductPriceSettings?: any | null, subjectTeaserSettings?: any | null, accordionSettings?: any | null, c016GlobalFilterSettings?: any | null, items?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmTeasableCommon_CmArticleImpl_Fragment
    & CmTeasableTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmTeasableCommon_CmAudioImpl_Fragment
    & CmTeasableTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmTeasableCommon_CmChannelImpl_Fragment
    & CmTeasableTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmTeasableCommon_CmCollectionImpl_Fragment
    & CmTeasableTeaserTarget_CmCollectionImpl_Fragment
    & CmCollection2_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmTeasableCommon_CmDownloadImpl_Fragment
    & CmTeasableTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmTeasableCommon_CmDynamicListImpl_Fragment
    & CmTeasableTeaserTarget_CmDynamicListImpl_Fragment
    & CmCollection2_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmTeasableCommon_CmExternalLinkImpl_Fragment
    & CmTeasableTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmTeasableCommon_CmGalleryImpl_Fragment
    & CmTeasableTeaserTarget_CmGalleryImpl_Fragment
    & CmCollection2_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmTeasableCommon_CmhtmlImpl_Fragment
    & CmTeasableTeaserTarget_CmhtmlImpl_Fragment
    & CmhtmlFragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmTeasableCommon_CmImageMapImpl_Fragment
    & CmTeasableTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmTeasableCommon_CmInteractiveImpl_Fragment
    & CmTeasableTeaserTarget_CmInteractiveImpl_Fragment
  ) | { __typename?: 'CMLinkableImpl' } | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTeasableCommon_CmLocTaxonomyImpl_Fragment
    & CmTeasableTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmTeasableCommon_CmMediaImpl_Fragment
    & CmTeasableTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmTeasableCommon_CmNavigationImpl_Fragment
    & CmTeasableTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmTeasableCommon_CmPersonImpl_Fragment
    & CmTeasableTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmTeasableCommon_CmPictureImpl_Fragment
    & CmTeasableTeaserTarget_CmPictureImpl_Fragment
    & CmPictureForCollectionFragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmTeasableCommon_CmPlaceholderImpl_Fragment
    & CmTeasableTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmTeasableCommon_CmProductImpl_Fragment
    & CmTeasableTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmTeasableCommon_CmQueryListImpl_Fragment
    & CmTeasableTeaserTarget_CmQueryListImpl_Fragment
    & CmCollection2_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmTeasableCommon_CmSelectionRulesImpl_Fragment
    & CmTeasableTeaserTarget_CmSelectionRulesImpl_Fragment
    & CmCollection2_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmTeasableCommon_CmSpinnerImpl_Fragment
    & CmTeasableTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTeasableCommon_CmTaxonomyImpl_Fragment
    & CmTeasableTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmTeasableCommon_CmTeasableImpl_Fragment
    & CmTeasableTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmTeasableCommon_CmTeaserImpl_Fragment
    & CmTeasableTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmTeasableCommon_CmVideoImpl_Fragment
    & CmTeasableTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmTeasableCommon_CmVisualImpl_Fragment
    & CmTeasableTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmTeasableCommon_FormEditorImpl_Fragment
    & CmTeasableTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmTeasableCommon_SosAmountIncreaseFormImpl_Fragment
    & CmTeasableTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmTeasableCommon_SosAuthorImpl_Fragment
    & CmTeasableTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmTeasableCommon_SosChartImpl_Fragment
    & CmTeasableTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmTeasableCommon_SosContactImpl_Fragment
    & CmTeasableTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmTeasableCommon_SosDonationCardImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationCardImpl_Fragment
    & SosDonationCardFragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmTeasableCommon_SosDonationCertificateImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmTeasableCommon_SosDonationFormImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmTeasableCommon_SosDonationProductImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationProductImpl_Fragment
    & SosDonationProductFragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmTeasableCommon_SosDonationProgressImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmTeasableCommon_SosDonationToolImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmTeasableCommon_SosEventImpl_Fragment
    & CmTeasableTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmTeasableCommon_SosFilterTeaserImpl_Fragment
    & CmTeasableTeaserTarget_SosFilterTeaserImpl_Fragment
    & SosFilterTeaserFragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmTeasableCommon_SosInternalLinkImpl_Fragment
    & CmTeasableTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmTeasableCommon_SosJobTeaserImpl_Fragment
    & CmTeasableTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTeasableCommon_SosLocationImpl_Fragment
    & CmTeasableTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmTeasableCommon_SosNewsImpl_Fragment
    & CmTeasableTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmTeasableCommon_SosNotificationImpl_Fragment
    & CmTeasableTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmTeasableCommon_SosOfferImpl_Fragment
    & CmTeasableTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmTeasableCommon_SosOrderFormImpl_Fragment
    & CmTeasableTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmTeasableCommon_SosOrganisationImpl_Fragment
    & CmTeasableTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmTeasableCommon_SosOverlayImpl_Fragment
    & CmTeasableTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmTeasableCommon_SosPressreleaseImpl_Fragment
    & CmTeasableTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmTeasableCommon_SosPublicationImpl_Fragment
    & CmTeasableTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmTeasableCommon_SosRedirectPageImpl_Fragment
    & CmTeasableTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmTeasableCommon_SosSpecialTopicCategoryImpl_Fragment
    & CmTeasableTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmTeasableCommon_SosSpecialTopicImpl_Fragment
    & CmTeasableTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmTeasableCommon_SosTeaserImpl_Fragment
    & CmTeasableTeaserTarget_SosTeaserImpl_Fragment
    & SosTeaserFragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmTeasableCommon_SosTextfragmentImpl_Fragment
    & CmTeasableTeaserTarget_SosTextfragmentImpl_Fragment
    & SosTextfragmentFragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmTeasableCommon_SosTooltipImpl_Fragment
    & CmTeasableTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmTeasableCommon_SosWimmelbildImpl_Fragment
    & CmTeasableTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmTeasableCommon_ViewTypeHeroCollection_Fragment
    & CmTeasableTeaserTarget_ViewTypeHeroCollection_Fragment
    & CmCollection2_ViewTypeHeroCollection_Fragment
  ) | null> | null, teasableItems?: Array<{ __typename?: 'CMArticleImpl' } | { __typename?: 'CMAudioImpl' } | { __typename?: 'CMChannelImpl' } | (
    { __typename?: 'CMCollectionImpl' }
    & CmCollection2_CmCollectionImpl_Fragment
  ) | { __typename?: 'CMDownloadImpl' } | (
    { __typename?: 'CMDynamicListImpl' }
    & CmCollection2_CmDynamicListImpl_Fragment
  ) | { __typename?: 'CMExternalLinkImpl' } | (
    { __typename?: 'CMGalleryImpl' }
    & CmCollection2_CmGalleryImpl_Fragment
  ) | { __typename?: 'CMHTMLImpl' } | { __typename?: 'CMImageMapImpl' } | { __typename?: 'CMInteractiveImpl' } | { __typename?: 'CMLocTaxonomyImpl' } | { __typename?: 'CMMediaImpl' } | { __typename?: 'CMNavigationImpl' } | { __typename?: 'CMPersonImpl' } | { __typename?: 'CMPictureImpl' } | { __typename?: 'CMPlaceholderImpl' } | { __typename?: 'CMProductImpl' } | (
    { __typename?: 'CMQueryListImpl' }
    & CmCollection2_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmCollection2_CmSelectionRulesImpl_Fragment
  ) | { __typename?: 'CMSpinnerImpl' } | { __typename?: 'CMTaxonomyImpl' } | { __typename?: 'CMTeasableImpl' } | { __typename?: 'CMTeaserImpl' } | { __typename?: 'CMVideoImpl' } | { __typename?: 'CMVisualImpl' } | { __typename?: 'FormEditorImpl' } | { __typename?: 'SOSAmountIncreaseFormImpl' } | { __typename?: 'SOSAuthorImpl' } | { __typename?: 'SOSChartImpl' } | { __typename?: 'SOSContactImpl' } | { __typename?: 'SOSDonationCardImpl' } | { __typename?: 'SOSDonationCertificateImpl' } | { __typename?: 'SOSDonationFormImpl' } | { __typename?: 'SOSDonationProductImpl' } | { __typename?: 'SOSDonationProgressImpl' } | { __typename?: 'SOSDonationToolImpl' } | { __typename?: 'SOSEventImpl' } | { __typename?: 'SOSFilterTeaserImpl' } | { __typename?: 'SOSInternalLinkImpl' } | { __typename?: 'SOSJobTeaserImpl' } | { __typename?: 'SOSLocationImpl' } | { __typename?: 'SOSNewsImpl' } | { __typename?: 'SOSNotificationImpl' } | { __typename?: 'SOSOfferImpl' } | { __typename?: 'SOSOrderFormImpl' } | { __typename?: 'SOSOrganisationImpl' } | { __typename?: 'SOSOverlayImpl' } | { __typename?: 'SOSPressreleaseImpl' } | { __typename?: 'SOSPublicationImpl' } | { __typename?: 'SOSRedirectPageImpl' } | { __typename?: 'SOSSpecialTopicCategoryImpl' } | { __typename?: 'SOSSpecialTopicImpl' } | { __typename?: 'SOSTeaserImpl' } | { __typename?: 'SOSTextfragmentImpl' } | { __typename?: 'SOSTooltipImpl' } | { __typename?: 'SOSWimmelbildImpl' } | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmCollection2_ViewTypeHeroCollection_Fragment
  ) | null> | null }
  & CmTeasableCommon_CmGalleryImpl_Fragment
  & CmTeasableLayout_CmGalleryImpl_Fragment
);

export type CmCollection_CmQueryListImpl_Fragment = (
  { __typename?: 'CMQueryListImpl', viewtype?: string | null, callToActionSettings?: any | null, downloadSettings?: any | null, teaserCarouselSettings?: any | null, queryListSettings?: any | null, donationProductPriceSettings?: any | null, subjectTeaserSettings?: any | null, accordionSettings?: any | null, c016GlobalFilterSettings?: any | null, items?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmTeasableCommon_CmArticleImpl_Fragment
    & CmTeasableTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmTeasableCommon_CmAudioImpl_Fragment
    & CmTeasableTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmTeasableCommon_CmChannelImpl_Fragment
    & CmTeasableTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmTeasableCommon_CmCollectionImpl_Fragment
    & CmTeasableTeaserTarget_CmCollectionImpl_Fragment
    & CmCollection2_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmTeasableCommon_CmDownloadImpl_Fragment
    & CmTeasableTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmTeasableCommon_CmDynamicListImpl_Fragment
    & CmTeasableTeaserTarget_CmDynamicListImpl_Fragment
    & CmCollection2_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmTeasableCommon_CmExternalLinkImpl_Fragment
    & CmTeasableTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmTeasableCommon_CmGalleryImpl_Fragment
    & CmTeasableTeaserTarget_CmGalleryImpl_Fragment
    & CmCollection2_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmTeasableCommon_CmhtmlImpl_Fragment
    & CmTeasableTeaserTarget_CmhtmlImpl_Fragment
    & CmhtmlFragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmTeasableCommon_CmImageMapImpl_Fragment
    & CmTeasableTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmTeasableCommon_CmInteractiveImpl_Fragment
    & CmTeasableTeaserTarget_CmInteractiveImpl_Fragment
  ) | { __typename?: 'CMLinkableImpl' } | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTeasableCommon_CmLocTaxonomyImpl_Fragment
    & CmTeasableTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmTeasableCommon_CmMediaImpl_Fragment
    & CmTeasableTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmTeasableCommon_CmNavigationImpl_Fragment
    & CmTeasableTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmTeasableCommon_CmPersonImpl_Fragment
    & CmTeasableTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmTeasableCommon_CmPictureImpl_Fragment
    & CmTeasableTeaserTarget_CmPictureImpl_Fragment
    & CmPictureForCollectionFragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmTeasableCommon_CmPlaceholderImpl_Fragment
    & CmTeasableTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmTeasableCommon_CmProductImpl_Fragment
    & CmTeasableTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmTeasableCommon_CmQueryListImpl_Fragment
    & CmTeasableTeaserTarget_CmQueryListImpl_Fragment
    & CmCollection2_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmTeasableCommon_CmSelectionRulesImpl_Fragment
    & CmTeasableTeaserTarget_CmSelectionRulesImpl_Fragment
    & CmCollection2_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmTeasableCommon_CmSpinnerImpl_Fragment
    & CmTeasableTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTeasableCommon_CmTaxonomyImpl_Fragment
    & CmTeasableTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmTeasableCommon_CmTeasableImpl_Fragment
    & CmTeasableTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmTeasableCommon_CmTeaserImpl_Fragment
    & CmTeasableTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmTeasableCommon_CmVideoImpl_Fragment
    & CmTeasableTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmTeasableCommon_CmVisualImpl_Fragment
    & CmTeasableTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmTeasableCommon_FormEditorImpl_Fragment
    & CmTeasableTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmTeasableCommon_SosAmountIncreaseFormImpl_Fragment
    & CmTeasableTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmTeasableCommon_SosAuthorImpl_Fragment
    & CmTeasableTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmTeasableCommon_SosChartImpl_Fragment
    & CmTeasableTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmTeasableCommon_SosContactImpl_Fragment
    & CmTeasableTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmTeasableCommon_SosDonationCardImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationCardImpl_Fragment
    & SosDonationCardFragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmTeasableCommon_SosDonationCertificateImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmTeasableCommon_SosDonationFormImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmTeasableCommon_SosDonationProductImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationProductImpl_Fragment
    & SosDonationProductFragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmTeasableCommon_SosDonationProgressImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmTeasableCommon_SosDonationToolImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmTeasableCommon_SosEventImpl_Fragment
    & CmTeasableTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmTeasableCommon_SosFilterTeaserImpl_Fragment
    & CmTeasableTeaserTarget_SosFilterTeaserImpl_Fragment
    & SosFilterTeaserFragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmTeasableCommon_SosInternalLinkImpl_Fragment
    & CmTeasableTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmTeasableCommon_SosJobTeaserImpl_Fragment
    & CmTeasableTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTeasableCommon_SosLocationImpl_Fragment
    & CmTeasableTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmTeasableCommon_SosNewsImpl_Fragment
    & CmTeasableTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmTeasableCommon_SosNotificationImpl_Fragment
    & CmTeasableTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmTeasableCommon_SosOfferImpl_Fragment
    & CmTeasableTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmTeasableCommon_SosOrderFormImpl_Fragment
    & CmTeasableTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmTeasableCommon_SosOrganisationImpl_Fragment
    & CmTeasableTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmTeasableCommon_SosOverlayImpl_Fragment
    & CmTeasableTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmTeasableCommon_SosPressreleaseImpl_Fragment
    & CmTeasableTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmTeasableCommon_SosPublicationImpl_Fragment
    & CmTeasableTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmTeasableCommon_SosRedirectPageImpl_Fragment
    & CmTeasableTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmTeasableCommon_SosSpecialTopicCategoryImpl_Fragment
    & CmTeasableTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmTeasableCommon_SosSpecialTopicImpl_Fragment
    & CmTeasableTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmTeasableCommon_SosTeaserImpl_Fragment
    & CmTeasableTeaserTarget_SosTeaserImpl_Fragment
    & SosTeaserFragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmTeasableCommon_SosTextfragmentImpl_Fragment
    & CmTeasableTeaserTarget_SosTextfragmentImpl_Fragment
    & SosTextfragmentFragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmTeasableCommon_SosTooltipImpl_Fragment
    & CmTeasableTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmTeasableCommon_SosWimmelbildImpl_Fragment
    & CmTeasableTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmTeasableCommon_ViewTypeHeroCollection_Fragment
    & CmTeasableTeaserTarget_ViewTypeHeroCollection_Fragment
    & CmCollection2_ViewTypeHeroCollection_Fragment
  ) | null> | null, teasableItems?: Array<{ __typename?: 'CMArticleImpl' } | { __typename?: 'CMAudioImpl' } | { __typename?: 'CMChannelImpl' } | (
    { __typename?: 'CMCollectionImpl' }
    & CmCollection2_CmCollectionImpl_Fragment
  ) | { __typename?: 'CMDownloadImpl' } | (
    { __typename?: 'CMDynamicListImpl' }
    & CmCollection2_CmDynamicListImpl_Fragment
  ) | { __typename?: 'CMExternalLinkImpl' } | (
    { __typename?: 'CMGalleryImpl' }
    & CmCollection2_CmGalleryImpl_Fragment
  ) | { __typename?: 'CMHTMLImpl' } | { __typename?: 'CMImageMapImpl' } | { __typename?: 'CMInteractiveImpl' } | { __typename?: 'CMLocTaxonomyImpl' } | { __typename?: 'CMMediaImpl' } | { __typename?: 'CMNavigationImpl' } | { __typename?: 'CMPersonImpl' } | { __typename?: 'CMPictureImpl' } | { __typename?: 'CMPlaceholderImpl' } | { __typename?: 'CMProductImpl' } | (
    { __typename?: 'CMQueryListImpl' }
    & CmCollection2_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmCollection2_CmSelectionRulesImpl_Fragment
  ) | { __typename?: 'CMSpinnerImpl' } | { __typename?: 'CMTaxonomyImpl' } | { __typename?: 'CMTeasableImpl' } | { __typename?: 'CMTeaserImpl' } | { __typename?: 'CMVideoImpl' } | { __typename?: 'CMVisualImpl' } | { __typename?: 'FormEditorImpl' } | { __typename?: 'SOSAmountIncreaseFormImpl' } | { __typename?: 'SOSAuthorImpl' } | { __typename?: 'SOSChartImpl' } | { __typename?: 'SOSContactImpl' } | { __typename?: 'SOSDonationCardImpl' } | { __typename?: 'SOSDonationCertificateImpl' } | { __typename?: 'SOSDonationFormImpl' } | { __typename?: 'SOSDonationProductImpl' } | { __typename?: 'SOSDonationProgressImpl' } | { __typename?: 'SOSDonationToolImpl' } | { __typename?: 'SOSEventImpl' } | { __typename?: 'SOSFilterTeaserImpl' } | { __typename?: 'SOSInternalLinkImpl' } | { __typename?: 'SOSJobTeaserImpl' } | { __typename?: 'SOSLocationImpl' } | { __typename?: 'SOSNewsImpl' } | { __typename?: 'SOSNotificationImpl' } | { __typename?: 'SOSOfferImpl' } | { __typename?: 'SOSOrderFormImpl' } | { __typename?: 'SOSOrganisationImpl' } | { __typename?: 'SOSOverlayImpl' } | { __typename?: 'SOSPressreleaseImpl' } | { __typename?: 'SOSPublicationImpl' } | { __typename?: 'SOSRedirectPageImpl' } | { __typename?: 'SOSSpecialTopicCategoryImpl' } | { __typename?: 'SOSSpecialTopicImpl' } | { __typename?: 'SOSTeaserImpl' } | { __typename?: 'SOSTextfragmentImpl' } | { __typename?: 'SOSTooltipImpl' } | { __typename?: 'SOSWimmelbildImpl' } | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmCollection2_ViewTypeHeroCollection_Fragment
  ) | null> | null }
  & CmTeasableCommon_CmQueryListImpl_Fragment
  & CmTeasableLayout_CmQueryListImpl_Fragment
);

export type CmCollection_CmSelectionRulesImpl_Fragment = (
  { __typename?: 'CMSelectionRulesImpl', viewtype?: string | null, callToActionSettings?: any | null, downloadSettings?: any | null, teaserCarouselSettings?: any | null, queryListSettings?: any | null, donationProductPriceSettings?: any | null, subjectTeaserSettings?: any | null, accordionSettings?: any | null, c016GlobalFilterSettings?: any | null, items?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmTeasableCommon_CmArticleImpl_Fragment
    & CmTeasableTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmTeasableCommon_CmAudioImpl_Fragment
    & CmTeasableTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmTeasableCommon_CmChannelImpl_Fragment
    & CmTeasableTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmTeasableCommon_CmCollectionImpl_Fragment
    & CmTeasableTeaserTarget_CmCollectionImpl_Fragment
    & CmCollection2_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmTeasableCommon_CmDownloadImpl_Fragment
    & CmTeasableTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmTeasableCommon_CmDynamicListImpl_Fragment
    & CmTeasableTeaserTarget_CmDynamicListImpl_Fragment
    & CmCollection2_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmTeasableCommon_CmExternalLinkImpl_Fragment
    & CmTeasableTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmTeasableCommon_CmGalleryImpl_Fragment
    & CmTeasableTeaserTarget_CmGalleryImpl_Fragment
    & CmCollection2_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmTeasableCommon_CmhtmlImpl_Fragment
    & CmTeasableTeaserTarget_CmhtmlImpl_Fragment
    & CmhtmlFragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmTeasableCommon_CmImageMapImpl_Fragment
    & CmTeasableTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmTeasableCommon_CmInteractiveImpl_Fragment
    & CmTeasableTeaserTarget_CmInteractiveImpl_Fragment
  ) | { __typename?: 'CMLinkableImpl' } | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTeasableCommon_CmLocTaxonomyImpl_Fragment
    & CmTeasableTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmTeasableCommon_CmMediaImpl_Fragment
    & CmTeasableTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmTeasableCommon_CmNavigationImpl_Fragment
    & CmTeasableTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmTeasableCommon_CmPersonImpl_Fragment
    & CmTeasableTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmTeasableCommon_CmPictureImpl_Fragment
    & CmTeasableTeaserTarget_CmPictureImpl_Fragment
    & CmPictureForCollectionFragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmTeasableCommon_CmPlaceholderImpl_Fragment
    & CmTeasableTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmTeasableCommon_CmProductImpl_Fragment
    & CmTeasableTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmTeasableCommon_CmQueryListImpl_Fragment
    & CmTeasableTeaserTarget_CmQueryListImpl_Fragment
    & CmCollection2_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmTeasableCommon_CmSelectionRulesImpl_Fragment
    & CmTeasableTeaserTarget_CmSelectionRulesImpl_Fragment
    & CmCollection2_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmTeasableCommon_CmSpinnerImpl_Fragment
    & CmTeasableTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTeasableCommon_CmTaxonomyImpl_Fragment
    & CmTeasableTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmTeasableCommon_CmTeasableImpl_Fragment
    & CmTeasableTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmTeasableCommon_CmTeaserImpl_Fragment
    & CmTeasableTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmTeasableCommon_CmVideoImpl_Fragment
    & CmTeasableTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmTeasableCommon_CmVisualImpl_Fragment
    & CmTeasableTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmTeasableCommon_FormEditorImpl_Fragment
    & CmTeasableTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmTeasableCommon_SosAmountIncreaseFormImpl_Fragment
    & CmTeasableTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmTeasableCommon_SosAuthorImpl_Fragment
    & CmTeasableTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmTeasableCommon_SosChartImpl_Fragment
    & CmTeasableTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmTeasableCommon_SosContactImpl_Fragment
    & CmTeasableTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmTeasableCommon_SosDonationCardImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationCardImpl_Fragment
    & SosDonationCardFragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmTeasableCommon_SosDonationCertificateImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmTeasableCommon_SosDonationFormImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmTeasableCommon_SosDonationProductImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationProductImpl_Fragment
    & SosDonationProductFragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmTeasableCommon_SosDonationProgressImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmTeasableCommon_SosDonationToolImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmTeasableCommon_SosEventImpl_Fragment
    & CmTeasableTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmTeasableCommon_SosFilterTeaserImpl_Fragment
    & CmTeasableTeaserTarget_SosFilterTeaserImpl_Fragment
    & SosFilterTeaserFragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmTeasableCommon_SosInternalLinkImpl_Fragment
    & CmTeasableTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmTeasableCommon_SosJobTeaserImpl_Fragment
    & CmTeasableTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTeasableCommon_SosLocationImpl_Fragment
    & CmTeasableTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmTeasableCommon_SosNewsImpl_Fragment
    & CmTeasableTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmTeasableCommon_SosNotificationImpl_Fragment
    & CmTeasableTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmTeasableCommon_SosOfferImpl_Fragment
    & CmTeasableTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmTeasableCommon_SosOrderFormImpl_Fragment
    & CmTeasableTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmTeasableCommon_SosOrganisationImpl_Fragment
    & CmTeasableTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmTeasableCommon_SosOverlayImpl_Fragment
    & CmTeasableTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmTeasableCommon_SosPressreleaseImpl_Fragment
    & CmTeasableTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmTeasableCommon_SosPublicationImpl_Fragment
    & CmTeasableTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmTeasableCommon_SosRedirectPageImpl_Fragment
    & CmTeasableTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmTeasableCommon_SosSpecialTopicCategoryImpl_Fragment
    & CmTeasableTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmTeasableCommon_SosSpecialTopicImpl_Fragment
    & CmTeasableTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmTeasableCommon_SosTeaserImpl_Fragment
    & CmTeasableTeaserTarget_SosTeaserImpl_Fragment
    & SosTeaserFragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmTeasableCommon_SosTextfragmentImpl_Fragment
    & CmTeasableTeaserTarget_SosTextfragmentImpl_Fragment
    & SosTextfragmentFragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmTeasableCommon_SosTooltipImpl_Fragment
    & CmTeasableTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmTeasableCommon_SosWimmelbildImpl_Fragment
    & CmTeasableTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmTeasableCommon_ViewTypeHeroCollection_Fragment
    & CmTeasableTeaserTarget_ViewTypeHeroCollection_Fragment
    & CmCollection2_ViewTypeHeroCollection_Fragment
  ) | null> | null, teasableItems?: Array<{ __typename?: 'CMArticleImpl' } | { __typename?: 'CMAudioImpl' } | { __typename?: 'CMChannelImpl' } | (
    { __typename?: 'CMCollectionImpl' }
    & CmCollection2_CmCollectionImpl_Fragment
  ) | { __typename?: 'CMDownloadImpl' } | (
    { __typename?: 'CMDynamicListImpl' }
    & CmCollection2_CmDynamicListImpl_Fragment
  ) | { __typename?: 'CMExternalLinkImpl' } | (
    { __typename?: 'CMGalleryImpl' }
    & CmCollection2_CmGalleryImpl_Fragment
  ) | { __typename?: 'CMHTMLImpl' } | { __typename?: 'CMImageMapImpl' } | { __typename?: 'CMInteractiveImpl' } | { __typename?: 'CMLocTaxonomyImpl' } | { __typename?: 'CMMediaImpl' } | { __typename?: 'CMNavigationImpl' } | { __typename?: 'CMPersonImpl' } | { __typename?: 'CMPictureImpl' } | { __typename?: 'CMPlaceholderImpl' } | { __typename?: 'CMProductImpl' } | (
    { __typename?: 'CMQueryListImpl' }
    & CmCollection2_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmCollection2_CmSelectionRulesImpl_Fragment
  ) | { __typename?: 'CMSpinnerImpl' } | { __typename?: 'CMTaxonomyImpl' } | { __typename?: 'CMTeasableImpl' } | { __typename?: 'CMTeaserImpl' } | { __typename?: 'CMVideoImpl' } | { __typename?: 'CMVisualImpl' } | { __typename?: 'FormEditorImpl' } | { __typename?: 'SOSAmountIncreaseFormImpl' } | { __typename?: 'SOSAuthorImpl' } | { __typename?: 'SOSChartImpl' } | { __typename?: 'SOSContactImpl' } | { __typename?: 'SOSDonationCardImpl' } | { __typename?: 'SOSDonationCertificateImpl' } | { __typename?: 'SOSDonationFormImpl' } | { __typename?: 'SOSDonationProductImpl' } | { __typename?: 'SOSDonationProgressImpl' } | { __typename?: 'SOSDonationToolImpl' } | { __typename?: 'SOSEventImpl' } | { __typename?: 'SOSFilterTeaserImpl' } | { __typename?: 'SOSInternalLinkImpl' } | { __typename?: 'SOSJobTeaserImpl' } | { __typename?: 'SOSLocationImpl' } | { __typename?: 'SOSNewsImpl' } | { __typename?: 'SOSNotificationImpl' } | { __typename?: 'SOSOfferImpl' } | { __typename?: 'SOSOrderFormImpl' } | { __typename?: 'SOSOrganisationImpl' } | { __typename?: 'SOSOverlayImpl' } | { __typename?: 'SOSPressreleaseImpl' } | { __typename?: 'SOSPublicationImpl' } | { __typename?: 'SOSRedirectPageImpl' } | { __typename?: 'SOSSpecialTopicCategoryImpl' } | { __typename?: 'SOSSpecialTopicImpl' } | { __typename?: 'SOSTeaserImpl' } | { __typename?: 'SOSTextfragmentImpl' } | { __typename?: 'SOSTooltipImpl' } | { __typename?: 'SOSWimmelbildImpl' } | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmCollection2_ViewTypeHeroCollection_Fragment
  ) | null> | null }
  & CmTeasableCommon_CmSelectionRulesImpl_Fragment
  & CmTeasableLayout_CmSelectionRulesImpl_Fragment
);

export type CmCollection_ViewTypeHeroCollection_Fragment = (
  { __typename?: 'ViewTypeHeroCollection', viewtype?: string | null, callToActionSettings?: any | null, downloadSettings?: any | null, teaserCarouselSettings?: any | null, queryListSettings?: any | null, donationProductPriceSettings?: any | null, subjectTeaserSettings?: any | null, accordionSettings?: any | null, c016GlobalFilterSettings?: any | null, items?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmTeasableCommon_CmArticleImpl_Fragment
    & CmTeasableTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmTeasableCommon_CmAudioImpl_Fragment
    & CmTeasableTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmTeasableCommon_CmChannelImpl_Fragment
    & CmTeasableTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmTeasableCommon_CmCollectionImpl_Fragment
    & CmTeasableTeaserTarget_CmCollectionImpl_Fragment
    & CmCollection2_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmTeasableCommon_CmDownloadImpl_Fragment
    & CmTeasableTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmTeasableCommon_CmDynamicListImpl_Fragment
    & CmTeasableTeaserTarget_CmDynamicListImpl_Fragment
    & CmCollection2_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmTeasableCommon_CmExternalLinkImpl_Fragment
    & CmTeasableTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmTeasableCommon_CmGalleryImpl_Fragment
    & CmTeasableTeaserTarget_CmGalleryImpl_Fragment
    & CmCollection2_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmTeasableCommon_CmhtmlImpl_Fragment
    & CmTeasableTeaserTarget_CmhtmlImpl_Fragment
    & CmhtmlFragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmTeasableCommon_CmImageMapImpl_Fragment
    & CmTeasableTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmTeasableCommon_CmInteractiveImpl_Fragment
    & CmTeasableTeaserTarget_CmInteractiveImpl_Fragment
  ) | { __typename?: 'CMLinkableImpl' } | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTeasableCommon_CmLocTaxonomyImpl_Fragment
    & CmTeasableTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmTeasableCommon_CmMediaImpl_Fragment
    & CmTeasableTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmTeasableCommon_CmNavigationImpl_Fragment
    & CmTeasableTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmTeasableCommon_CmPersonImpl_Fragment
    & CmTeasableTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmTeasableCommon_CmPictureImpl_Fragment
    & CmTeasableTeaserTarget_CmPictureImpl_Fragment
    & CmPictureForCollectionFragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmTeasableCommon_CmPlaceholderImpl_Fragment
    & CmTeasableTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmTeasableCommon_CmProductImpl_Fragment
    & CmTeasableTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmTeasableCommon_CmQueryListImpl_Fragment
    & CmTeasableTeaserTarget_CmQueryListImpl_Fragment
    & CmCollection2_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmTeasableCommon_CmSelectionRulesImpl_Fragment
    & CmTeasableTeaserTarget_CmSelectionRulesImpl_Fragment
    & CmCollection2_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmTeasableCommon_CmSpinnerImpl_Fragment
    & CmTeasableTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTeasableCommon_CmTaxonomyImpl_Fragment
    & CmTeasableTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmTeasableCommon_CmTeasableImpl_Fragment
    & CmTeasableTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmTeasableCommon_CmTeaserImpl_Fragment
    & CmTeasableTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmTeasableCommon_CmVideoImpl_Fragment
    & CmTeasableTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmTeasableCommon_CmVisualImpl_Fragment
    & CmTeasableTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmTeasableCommon_FormEditorImpl_Fragment
    & CmTeasableTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmTeasableCommon_SosAmountIncreaseFormImpl_Fragment
    & CmTeasableTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmTeasableCommon_SosAuthorImpl_Fragment
    & CmTeasableTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmTeasableCommon_SosChartImpl_Fragment
    & CmTeasableTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmTeasableCommon_SosContactImpl_Fragment
    & CmTeasableTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmTeasableCommon_SosDonationCardImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationCardImpl_Fragment
    & SosDonationCardFragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmTeasableCommon_SosDonationCertificateImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmTeasableCommon_SosDonationFormImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmTeasableCommon_SosDonationProductImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationProductImpl_Fragment
    & SosDonationProductFragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmTeasableCommon_SosDonationProgressImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmTeasableCommon_SosDonationToolImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmTeasableCommon_SosEventImpl_Fragment
    & CmTeasableTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmTeasableCommon_SosFilterTeaserImpl_Fragment
    & CmTeasableTeaserTarget_SosFilterTeaserImpl_Fragment
    & SosFilterTeaserFragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmTeasableCommon_SosInternalLinkImpl_Fragment
    & CmTeasableTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmTeasableCommon_SosJobTeaserImpl_Fragment
    & CmTeasableTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTeasableCommon_SosLocationImpl_Fragment
    & CmTeasableTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmTeasableCommon_SosNewsImpl_Fragment
    & CmTeasableTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmTeasableCommon_SosNotificationImpl_Fragment
    & CmTeasableTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmTeasableCommon_SosOfferImpl_Fragment
    & CmTeasableTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmTeasableCommon_SosOrderFormImpl_Fragment
    & CmTeasableTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmTeasableCommon_SosOrganisationImpl_Fragment
    & CmTeasableTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmTeasableCommon_SosOverlayImpl_Fragment
    & CmTeasableTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmTeasableCommon_SosPressreleaseImpl_Fragment
    & CmTeasableTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmTeasableCommon_SosPublicationImpl_Fragment
    & CmTeasableTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmTeasableCommon_SosRedirectPageImpl_Fragment
    & CmTeasableTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmTeasableCommon_SosSpecialTopicCategoryImpl_Fragment
    & CmTeasableTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmTeasableCommon_SosSpecialTopicImpl_Fragment
    & CmTeasableTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmTeasableCommon_SosTeaserImpl_Fragment
    & CmTeasableTeaserTarget_SosTeaserImpl_Fragment
    & SosTeaserFragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmTeasableCommon_SosTextfragmentImpl_Fragment
    & CmTeasableTeaserTarget_SosTextfragmentImpl_Fragment
    & SosTextfragmentFragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmTeasableCommon_SosTooltipImpl_Fragment
    & CmTeasableTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmTeasableCommon_SosWimmelbildImpl_Fragment
    & CmTeasableTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmTeasableCommon_ViewTypeHeroCollection_Fragment
    & CmTeasableTeaserTarget_ViewTypeHeroCollection_Fragment
    & CmCollection2_ViewTypeHeroCollection_Fragment
  ) | null> | null, teasableItems?: Array<{ __typename?: 'CMArticleImpl' } | { __typename?: 'CMAudioImpl' } | { __typename?: 'CMChannelImpl' } | (
    { __typename?: 'CMCollectionImpl' }
    & CmCollection2_CmCollectionImpl_Fragment
  ) | { __typename?: 'CMDownloadImpl' } | (
    { __typename?: 'CMDynamicListImpl' }
    & CmCollection2_CmDynamicListImpl_Fragment
  ) | { __typename?: 'CMExternalLinkImpl' } | (
    { __typename?: 'CMGalleryImpl' }
    & CmCollection2_CmGalleryImpl_Fragment
  ) | { __typename?: 'CMHTMLImpl' } | { __typename?: 'CMImageMapImpl' } | { __typename?: 'CMInteractiveImpl' } | { __typename?: 'CMLocTaxonomyImpl' } | { __typename?: 'CMMediaImpl' } | { __typename?: 'CMNavigationImpl' } | { __typename?: 'CMPersonImpl' } | { __typename?: 'CMPictureImpl' } | { __typename?: 'CMPlaceholderImpl' } | { __typename?: 'CMProductImpl' } | (
    { __typename?: 'CMQueryListImpl' }
    & CmCollection2_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmCollection2_CmSelectionRulesImpl_Fragment
  ) | { __typename?: 'CMSpinnerImpl' } | { __typename?: 'CMTaxonomyImpl' } | { __typename?: 'CMTeasableImpl' } | { __typename?: 'CMTeaserImpl' } | { __typename?: 'CMVideoImpl' } | { __typename?: 'CMVisualImpl' } | { __typename?: 'FormEditorImpl' } | { __typename?: 'SOSAmountIncreaseFormImpl' } | { __typename?: 'SOSAuthorImpl' } | { __typename?: 'SOSChartImpl' } | { __typename?: 'SOSContactImpl' } | { __typename?: 'SOSDonationCardImpl' } | { __typename?: 'SOSDonationCertificateImpl' } | { __typename?: 'SOSDonationFormImpl' } | { __typename?: 'SOSDonationProductImpl' } | { __typename?: 'SOSDonationProgressImpl' } | { __typename?: 'SOSDonationToolImpl' } | { __typename?: 'SOSEventImpl' } | { __typename?: 'SOSFilterTeaserImpl' } | { __typename?: 'SOSInternalLinkImpl' } | { __typename?: 'SOSJobTeaserImpl' } | { __typename?: 'SOSLocationImpl' } | { __typename?: 'SOSNewsImpl' } | { __typename?: 'SOSNotificationImpl' } | { __typename?: 'SOSOfferImpl' } | { __typename?: 'SOSOrderFormImpl' } | { __typename?: 'SOSOrganisationImpl' } | { __typename?: 'SOSOverlayImpl' } | { __typename?: 'SOSPressreleaseImpl' } | { __typename?: 'SOSPublicationImpl' } | { __typename?: 'SOSRedirectPageImpl' } | { __typename?: 'SOSSpecialTopicCategoryImpl' } | { __typename?: 'SOSSpecialTopicImpl' } | { __typename?: 'SOSTeaserImpl' } | { __typename?: 'SOSTextfragmentImpl' } | { __typename?: 'SOSTooltipImpl' } | { __typename?: 'SOSWimmelbildImpl' } | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmCollection2_ViewTypeHeroCollection_Fragment
  ) | null> | null }
  & CmTeasableCommon_ViewTypeHeroCollection_Fragment
  & CmTeasableLayout_ViewTypeHeroCollection_Fragment
);

export type CmCollectionFragment = CmCollection_CmCollectionImpl_Fragment | CmCollection_CmDynamicListImpl_Fragment | CmCollection_CmGalleryImpl_Fragment | CmCollection_CmQueryListImpl_Fragment | CmCollection_CmSelectionRulesImpl_Fragment | CmCollection_ViewTypeHeroCollection_Fragment;

export const CmCollectionFragmentDoc = gql`
    fragment CMCollection on CMCollection {
  ...CMTeasableCommon
  ...CMTeasableLayout
  viewtype
  items {
    ...CMTeasableCommon
    ...CMTeasableTeaserTarget
    ...CMPictureForCollection
    ...CMExternalLink
    ...CMDownload
    ...CMCollection2
    ...SOSTeaser
    ...SOSFilterTeaser
    ...CMHTML
    ...SOSTextfragment
    ...SOSDonationCard
    ...SOSDonationProduct
  }
  teasableItems {
    ...CMCollection2
  }
  callToActionSettings: settings(
    paths: ["callToActionDisabled", "callToActionCustomText", "callToActionLink"]
  )
  downloadSettings: settings(paths: ["downloadDesktop", "showMoreCount"])
  teaserCarouselSettings: settings(
    paths: ["gallery.autoplay", "gallery.autoplay.speed", "gallery.imageslide.speed"]
  )
  queryListSettings: settings(
    paths: ["limit", "callToActionCustomText", "loadMore", "order"]
  )
  donationProductPriceSettings: settings(
    paths: ["donationProductPriceSliderMaxValue", "donationProductPriceSliderStartValue"]
  )
  subjectTeaserSettings: settings(
    paths: ["numberTilesDesktop", "numberTilesMobile", "loadMore"]
  )
  accordionSettings: settings(paths: ["accordionOpen"])
  c016GlobalFilterSettings: settings(
    paths: ["numberTilesDesktop", "numberTilesMobile", "callToActionCustomText", "showMoreCount", "teaser.max.length"]
  )
}
    ${CmTeasableCommonFragmentDoc}
${CmTeasableLayoutFragmentDoc}
${CmTeasableTeaserTargetFragmentDoc}
${CmPictureForCollectionFragmentDoc}
${CmExternalLinkFragmentDoc}
${CmDownloadFragmentDoc}
${CmCollection2FragmentDoc}
${SosTeaserFragmentDoc}
${SosFilterTeaserFragmentDoc}
${CmhtmlFragmentDoc}
${SosTextfragmentFragmentDoc}
${SosDonationCardFragmentDoc}
${SosDonationProductFragmentDoc}`;